module.exports = __webpack_public_path__ + "img/right-from-bracket-solid.5fbff4ac.svg";